import { render } from "./website-web.vue?vue&type=template&id=775ed1c3&scoped=true"
import script from "./website-web.vue?vue&type=script&lang=js"
export * from "./website-web.vue?vue&type=script&lang=js"

import "./website-web.vue?vue&type=style&index=0&id=775ed1c3&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/xiaomeng_tech/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775ed1c3"]])

export default __exports__